import React from 'react';
import { navList } from './page_structre_config'
import Nav from './page_structures/Nav/nav';
import logo from './assets/oppenfuture.png'
import Banner from './page_structures/Banner/Banner'
import WhyUse3D from './page_structures/WhyUse3D/WhyUse3D'
import ShowScene from './page_structures/ShowScene/ShowScene'
import CoreFunc from './page_structures/coreFunc/CoreFunc'
import Footer from './page_structures/Footer/Footer'
import ShowEffect from './page_structures/ShowEffect/ShowEffect'
import Service from './page_structures/Service/Service'
import Process from './page_structures/Process/Process'
import Form from './page_structures/Form/Form'

import './App.css';

function App() {
  return (
    <div className="App">
       <Nav navList={navList} logo={logo}/>
       <Banner/>
        <WhyUse3D/>
        <ShowScene/>
        <CoreFunc/>
        <ShowEffect/>
        <Service/>
        <Process/>
        <Form/>
        <Footer/>
    </div>
  );
}

export default App;
